import { render } from "./ReservationsByPlay.vue?vue&type=template&id=6d2167c8&scoped=true"
import script from "./ReservationsByPlay.vue?vue&type=script&lang=js"
export * from "./ReservationsByPlay.vue?vue&type=script&lang=js"

import "./ReservationsByPlay.vue?vue&type=style&index=0&id=6d2167c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2167c8"]])

export default __exports__